import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// ── 메뉴 항목 배열 (추후 화면 추가 시 여기에만 추가)
const MENU_ITEMS = [
  { label: '투자 종합현황', path: '/mobile/dashboard',   icon: '📊' },
  { label: '차수별 현황',   path: '/mobile/turn-status', icon: '📋' },
  { label: '시세 그래프',   path: '/mobile/stock-chart', icon: '📈' },
  { label: '매수 / 매도',   path: '/mobile/quick-trade', icon: '🔄' },
  { label: '잔고 확인',     path: '/mobile/balance',     icon: '💰' },
];

export default function Drawer({ open, onClose }) {
  const navigate      = useNavigate();
  const { pathname }  = useLocation();
  const { logout }    = useAuth();

  const handleNav = (path) => {
    navigate(path);
    onClose();
  };

  const handleLogout = () => {
    onClose();
    logout();
  };

  return (
    <>
      {/* 반투명 오버레이 — 탭하면 닫힘 */}
      <div
        className={`mb-drawer-overlay${open ? ' open' : ''}`}
        onClick={onClose}
      />

      {/* 좌측 슬라이드 패널 */}
      <div className={`mb-drawer-panel${open ? ' open' : ''}`}>
        {/* 드로어 헤더 */}
        <div className="mb-drawer-header">
          <span className="mb-drawer-title">K.G.B 투자</span>
          <button className="mb-drawer-close" onClick={onClose}>✕</button>
        </div>

        {/* 메뉴 목록 */}
        <nav className="mb-drawer-menu">
          {MENU_ITEMS.map(item => {
            const isActive = pathname.startsWith(item.path);
            return (
              <button
                key={item.path}
                className={`mb-drawer-item${isActive ? ' active' : ''}`}
                onClick={() => handleNav(item.path)}
              >
                <span className="mb-drawer-item-icon">{item.icon}</span>
                <span className="mb-drawer-item-label">{item.label}</span>
              </button>
            );
          })}

          {/* 구분선 */}
          <div className="mb-drawer-divider" />

          {/* PC 화면으로 가기 */}
          <button
            className="mb-drawer-item"
            onClick={() => handleNav('/')}
          >
            <span className="mb-drawer-item-icon">🖥️</span>
            <span className="mb-drawer-item-label">PC 화면으로 가기</span>
          </button>

          {/* 로그아웃 */}
          <button
            className="mb-drawer-item mb-drawer-item-logout"
            onClick={handleLogout}
          >
            <span className="mb-drawer-item-icon">🚪</span>
            <span className="mb-drawer-item-label">로그아웃</span>
          </button>
        </nav>
      </div>
    </>
  );
}
